import { motion } from "framer-motion";
import { FEATURES } from "@/data/content";

function SectionLabel({ children }) {
  return (
    <div className="inline-flex items-center gap-3">
      <span className="h-px w-8 bg-[#e01e37]" />
      <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#e01e37]">
        {children}
      </span>
    </div>
  );
}

export default function Features() {
  return (
    <section id="funktionen" className="relative py-16 sm:py-24 lg:py-32" data-testid="features-section">
      <div className="absolute inset-0 grid-bg-fine opacity-40" />
      <div className="relative mx-auto max-w-[1400px] px-6 lg:px-10">
        <div id="plattform" className="max-w-3xl">
          <SectionLabel>Plattform</SectionLabel>
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className="mt-6 font-display font-extrabold tracking-tight text-white leading-[1.02] text-4xl sm:text-5xl lg:text-6xl"
          >
            Eine Plattform.<br />
            <span className="text-white/40">Alle Finanzprozesse.</span>
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="mt-6 max-w-xl text-base lg:text-lg text-white/55 leading-relaxed"
          >
            Sechs Kernbausteine, eine kohärente Infrastruktur. Alles über eine
            API, ein Ledger und ein Compliance-Fundament.
          </motion.p>
        </div>

        {/* Technical grid with exposed 1px borders */}
        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {FEATURES.map((f, i) => (
            <motion.div
              key={f.id}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className="group relative bg-[#05060a] p-8 lg:p-10 transition-colors duration-500 hover:bg-[#0a0c12]"
              data-testid={`feature-card-${f.id}`}
            >
              {/* top accent line on hover */}
              <span className="absolute left-0 top-0 h-0.5 w-0 bg-[#e01e37] transition-[width] duration-500 group-hover:w-full" />

              <div className="flex items-start justify-between">
                <div className="flex h-12 w-12 items-center justify-center border border-white/10 text-white/80 transition-colors duration-300 group-hover:border-[#e01e37]/50 group-hover:text-[#e01e37]">
                  <f.icon className="h-5 w-5" strokeWidth={1.5} />
                </div>
                <span className="font-mono text-xs text-white/25">{f.id}</span>
              </div>

              <h3 className="mt-8 font-display text-xl lg:text-2xl font-bold tracking-tight text-white">
                {f.title}
              </h3>
              <p className="mt-4 text-sm lg:text-[15px] leading-relaxed text-white/50">
                {f.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
